var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Emit, Prop, Vue, } from "vue-property-decorator";
import ThicknessElement from "../../components/articleattributes/thicknesselement.vue";
let ThicknessForm = class ThicknessForm extends Vue {
    constructor() {
        super(...arguments);
        this.value = 0;
    }
    valueChanged() { return this.value; }
    onChange(t) {
        this.value = t;
        this.valueChanged();
    }
    created() { this.value = this.defaultValue; }
};
__decorate([
    Prop({ required: true })
], ThicknessForm.prototype, "defaultValue", void 0);
__decorate([
    Prop({ required: true })
], ThicknessForm.prototype, "disabled", void 0);
__decorate([
    Prop({ required: true })
], ThicknessForm.prototype, "shopConfig", void 0);
__decorate([
    Emit()
], ThicknessForm.prototype, "valueChanged", null);
ThicknessForm = __decorate([
    Component({
        components: {
            ThicknessElement,
        },
        name: "ThicknessForm",
    })
], ThicknessForm);
export default ThicknessForm;
